$(function () {

    var iconPanel = $('.icon_panel');

    if (iconPanel.length < 1) {
        return;
    }

    iconPanel.find('.icon_panel__row').align({
        selector: '.column .column__title, .column .column__text',
    });

});